export const SANDBOX_DOCUMENTATION_LINK = 'https://docs.pluggy.ai/docs/sandbox'
